import { render, staticRenderFns } from "./ed-fun-sections.component.vue?vue&type=template&id=2eedb1ea&scoped=true&"
import script from "./ed-fun-sections.component.ts?vue&type=script&lang=ts&"
export * from "./ed-fun-sections.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-fun-sections.component.scss?vue&type=style&index=0&id=2eedb1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eedb1ea",
  null
  
)

export default component.exports